import { hotScores } from "@/mocks/sportsData";

export default function HotScoresBar() {
  return (
    <section className="w-full px-4 md:px-6 -mt-1 relative z-20">
      <div className="max-w-7xl mx-auto">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 px-6 py-4 overflow-hidden">
          <div className="flex items-center gap-4 overflow-x-auto scrollbar-hide">
            <div className="flex items-center gap-2 flex-shrink-0 pr-4 border-r border-background-200/70">
              <div className="w-2 h-2 bg-accent-500 rounded-full animate-pulse"></div>
              <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">实时比分</span>
            </div>
            {hotScores.map((item, i) => (
              <div
                key={i}
                className="flex items-center gap-3 flex-shrink-0 px-4 py-2 bg-background-100 rounded-xl hover:bg-background-200/70 cursor-pointer transition-colors"
              >
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.league}</span>
                <span className="text-sm font-medium text-foreground-900 whitespace-nowrap">{item.match}</span>
                <span className="text-sm font-bold text-primary-600 whitespace-nowrap">{item.score}</span>
                <span className="text-xs text-accent-600 whitespace-nowrap">{item.status}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}